import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6309ee1b"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "lds-ring" }, [
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div")
], -1))
const _hoisted_2 = [
  _hoisted_1
]

import { computed } from "vue";
import { useStore } from "vuex";


export default /*#__PURE__*/_defineComponent({
  __name: 'CardChart',
  props: {
  isCentered: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {



const store = useStore();
const isLoadingReport = computed(() => store.state.report.isLoadingReport);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "wrapper-card-total h-100",
    style: _normalizeStyle({ minHeight: isLoadingReport.value ? '300px' : '' })
  }, [
    _createElementVNode("div", {
      class: _normalizeClass([{
        'd-flex align-items-center justify-content-center': __props.isCentered,
      }, "wrapper-card w-100 p-2 p-lg-4 h-100"])
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["loading d-flex align-items-center justify-content-center", { active: isLoadingReport.value }])
    }, _hoisted_2, 2)
  ], 4))
}
}

})